// Traduções deste componente — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'auth.mfaCard.copied': 'Copiado.',
    'auth.mfaCard.copy': 'Copiar',
    'auth.mfaCard.toastEnabled': 'Autenticação em dois fatores ativada.',
    'auth.mfaCard.toastDisabled': 'Autenticação em dois fatores desativada.',
    'auth.mfaCard.toastCodesRegenerated': 'Novos códigos de recuperação gerados.',
    'auth.mfaCard.setupRequiredAlert': 'A autenticação em dois fatores é obrigatória para sua conta. Conclua a configuração para continuar.',
    'auth.mfaCard.title': 'Autenticação em dois fatores',
    'auth.mfaCard.activeSince': 'Ativa desde {{date}}',
    'auth.mfaCard.activeSinceSetup': 'a configuração',
    'auth.mfaCard.notConfigured': 'Ainda não configurada',
    'auth.mfaCard.statusActive': 'Ativa',
    'auth.mfaCard.statusInactive': 'Inativa',
    'auth.mfaCard.newRecoveryCodes': 'Novos códigos',
    'auth.mfaCard.disable': 'Desativar',
    'auth.mfaCard.setupNow': 'Configurar agora',
    'auth.mfaCard.recoveryCodesLeft_one': '{{count}} código de recuperação disponível',
    'auth.mfaCard.recoveryCodesLeft_other': '{{count}} códigos de recuperação disponíveis',
    'auth.mfaCard.setupTitle': 'Configure seu aplicativo autenticador',
    'auth.mfaCard.setupInstructions': 'Leia o QR code com seu aplicativo autenticador ou informe a chave manualmente.',
    'auth.mfaCard.accountName': 'Nome da conta',
    'auth.mfaCard.setupKey': 'Chave de configuração',
    'auth.mfaCard.confirmInstructions': 'Informe o código exibido no aplicativo para confirmar a configuração.',
    'auth.mfaCard.appCodeLabel': 'Código do aplicativo',
    'auth.mfaCard.confirmAndActivate': 'Confirmar e ativar',
    'auth.mfaCard.recoveryCodesTitle': 'Códigos de recuperação',
    'auth.mfaCard.recoveryCodesWarning': 'Guarde estes códigos em um local seguro. Cada código pode ser usado apenas uma vez.',
    'auth.mfaCard.toastCodesCopied': 'Códigos copiados.',
    'auth.mfaCard.copyAll': 'Copiar todos',
    'auth.mfaCard.saved': 'Já salvei',
    'auth.mfaCard.disableDialogTitle': 'Desativar autenticação em dois fatores',
    'auth.mfaCard.regenerateDialogTitle': 'Gerar novos códigos de recuperação',
    'auth.mfaCard.disableDialogHint': 'Informe sua senha para desativar a proteção adicional da conta.',
    'auth.mfaCard.regenerateDialogHint': 'Informe sua senha para invalidar os códigos antigos e gerar novos.',
    'auth.mfaCard.passwordLabel': 'Senha atual',
  },
  en: {
    'auth.mfaCard.copied': 'Copied.',
    'auth.mfaCard.copy': 'Copy',
    'auth.mfaCard.toastEnabled': 'Two-factor authentication enabled.',
    'auth.mfaCard.toastDisabled': 'Two-factor authentication disabled.',
    'auth.mfaCard.toastCodesRegenerated': 'New recovery codes generated.',
    'auth.mfaCard.setupRequiredAlert': 'Two-factor authentication is required for your account. Complete setup to continue.',
    'auth.mfaCard.title': 'Two-factor authentication',
    'auth.mfaCard.activeSince': 'Active since {{date}}',
    'auth.mfaCard.activeSinceSetup': 'setup',
    'auth.mfaCard.notConfigured': 'Not configured yet',
    'auth.mfaCard.statusActive': 'Active',
    'auth.mfaCard.statusInactive': 'Inactive',
    'auth.mfaCard.newRecoveryCodes': 'New codes',
    'auth.mfaCard.disable': 'Disable',
    'auth.mfaCard.setupNow': 'Set up now',
    'auth.mfaCard.recoveryCodesLeft_one': '{{count}} recovery code available',
    'auth.mfaCard.recoveryCodesLeft_other': '{{count}} recovery codes available',
    'auth.mfaCard.setupTitle': 'Set up your authenticator app',
    'auth.mfaCard.setupInstructions': 'Scan the QR code with your authenticator app or enter the key manually.',
    'auth.mfaCard.accountName': 'Account name',
    'auth.mfaCard.setupKey': 'Setup key',
    'auth.mfaCard.confirmInstructions': 'Enter the code shown in the app to confirm setup.',
    'auth.mfaCard.appCodeLabel': 'App code',
    'auth.mfaCard.confirmAndActivate': 'Confirm and enable',
    'auth.mfaCard.recoveryCodesTitle': 'Recovery codes',
    'auth.mfaCard.recoveryCodesWarning': 'Store these codes in a safe place. Each code can only be used once.',
    'auth.mfaCard.toastCodesCopied': 'Codes copied.',
    'auth.mfaCard.copyAll': 'Copy all',
    'auth.mfaCard.saved': 'I saved them',
    'auth.mfaCard.disableDialogTitle': 'Disable two-factor authentication',
    'auth.mfaCard.regenerateDialogTitle': 'Generate new recovery codes',
    'auth.mfaCard.disableDialogHint': 'Enter your password to disable the additional account protection.',
    'auth.mfaCard.regenerateDialogHint': 'Enter your password to invalidate the old codes and generate new ones.',
    'auth.mfaCard.passwordLabel': 'Current password',
  },
  es: {
    'auth.mfaCard.copied': 'Copiado.',
    'auth.mfaCard.copy': 'Copiar',
    'auth.mfaCard.toastEnabled': 'Autenticación en dos pasos activada.',
    'auth.mfaCard.toastDisabled': 'Autenticación en dos pasos desactivada.',
    'auth.mfaCard.toastCodesRegenerated': 'Se generaron nuevos códigos de recuperación.',
    'auth.mfaCard.setupRequiredAlert': 'La autenticación en dos pasos es obligatoria para tu cuenta. Completa la configuración para continuar.',
    'auth.mfaCard.title': 'Autenticación en dos pasos',
    'auth.mfaCard.activeSince': 'Activa desde {{date}}',
    'auth.mfaCard.activeSinceSetup': 'la configuración',
    'auth.mfaCard.notConfigured': 'Aún no configurada',
    'auth.mfaCard.statusActive': 'Activa',
    'auth.mfaCard.statusInactive': 'Inactiva',
    'auth.mfaCard.newRecoveryCodes': 'Nuevos códigos',
    'auth.mfaCard.disable': 'Desactivar',
    'auth.mfaCard.setupNow': 'Configurar ahora',
    'auth.mfaCard.recoveryCodesLeft_one': '{{count}} código de recuperación disponible',
    'auth.mfaCard.recoveryCodesLeft_other': '{{count}} códigos de recuperación disponibles',
    'auth.mfaCard.setupTitle': 'Configura tu aplicación de autenticación',
    'auth.mfaCard.setupInstructions': 'Escanea el código QR con tu aplicación de autenticación o introduce la clave manualmente.',
    'auth.mfaCard.accountName': 'Nombre de la cuenta',
    'auth.mfaCard.setupKey': 'Clave de configuración',
    'auth.mfaCard.confirmInstructions': 'Introduce el código que aparece en la aplicación para confirmar la configuración.',
    'auth.mfaCard.appCodeLabel': 'Código de la aplicación',
    'auth.mfaCard.confirmAndActivate': 'Confirmar y activar',
    'auth.mfaCard.recoveryCodesTitle': 'Códigos de recuperación',
    'auth.mfaCard.recoveryCodesWarning': 'Guarda estos códigos en un lugar seguro. Cada código se puede usar una sola vez.',
    'auth.mfaCard.toastCodesCopied': 'Códigos copiados.',
    'auth.mfaCard.copyAll': 'Copiar todos',
    'auth.mfaCard.saved': 'Ya los guardé',
    'auth.mfaCard.disableDialogTitle': 'Desactivar la autenticación en dos pasos',
    'auth.mfaCard.regenerateDialogTitle': 'Generar nuevos códigos de recuperación',
    'auth.mfaCard.disableDialogHint': 'Introduce tu contraseña para desactivar la protección adicional de la cuenta.',
    'auth.mfaCard.regenerateDialogHint': 'Introduce tu contraseña para invalidar los códigos anteriores y generar nuevos.',
    'auth.mfaCard.passwordLabel': 'Contraseña actual',
  },
}
